import HeaderOverhaul from '@/components/elements/headerOverhaul'

import RichText from '../../elements/texts/richText'

const WhoWeAre = ({ data }) => {
  const { header, description } = data
  return (
    <div className="who-we-are-wrapper">
      <HeaderOverhaul className="who-we-are-header" header={header} subtitle />
      <div className="who-we-are-description-container">
        <RichText content={description} />
      </div>
    </div>
  )
}

export default WhoWeAre
